import { Pipe, PipeTransform } from '@angular/core';
import { Entity } from './classes/entity.class';
import { PlanningHasEntity } from './classes/planning-has-entity.class';
import { Planning } from './classes/planning.class';
import { Utils } from './utils.class';

@Pipe({
    name: 'multiple',
    standalone: false,
})
export class MultiplePipe implements PipeTransform {
    transform(
        entityId: number,
        ownPlanning: PlanningHasEntity,
        planning: Planning[],
        entitiesMap: Map<number, Entity>
    ): boolean {
        let multiple = false;
        if (entityId && entitiesMap.get(entityId)?.use_once) {
            planning?.forEach(pln => {
                pln.planning_has?.forEach(plnh => {
                    if (
                        plnh.id !== ownPlanning.id &&
                        (plnh.entity_id === entityId ||
                            plnh.truck_entity_id === entityId ||
                            plnh.lowloader_entity_id === entityId) &&
                        Utils.hourDiff(ownPlanning, plnh) < 12
                    ) {
                        multiple = true;
                    }
                });
            });
        }

        return multiple;
    }
}
